import React from 'react';
import ReactPlayer from 'react-player';
import { VideoPlayerWrapper } from '../markdown.style';
export default function VideoPlayer(_ref) {
  var {
    url = 'https://www.youtube.com/watch?v=92Oonxjm79E&list=PLBg8GR5ao-ayGE74T7X8ojr-N_hdSg0E-'
  } = _ref;
  return /*#__PURE__*/React.createElement(VideoPlayerWrapper, null, /*#__PURE__*/React.createElement(ReactPlayer, {
    className: "react-player",
    url: url,
    width: "100%",
    height: "100%"
  }));
}